document.querySelectorAll('.footer-block__heading').forEach(function(heading){
 heading.addEventListener('click', function(){
   const parent = this.parentElement;
   parent.classList.toggle('active');
 });
});


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".sol-header-bar");

  let lastScroll = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;

    // activate sticky after some scroll
    if (currentScroll > 0) {
      header.classList.add("sticky-active");

      if (currentScroll > lastScroll) {
        // scrolling DOWN
        header.classList.add("hide-header");
      } else {
        // scrolling UP
        header.classList.remove("hide-header");
      }

    } else {
      // top of page reset
      header.classList.remove("sticky-active");
      header.classList.remove("hide-header");
    }

    lastScroll = currentScroll;
  });
});



document.querySelectorAll('.shop-now-btn[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));
    if (!target) return;

    // const offset = 80; // adjust if header is sticky
    // const top = target.offsetTop - offset;

    const top = target.offsetTop;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });
});



document.addEventListener('click', function(e) {
  const btn = e.target.closest('.discount_btn');
  if (!btn) return;

  e.preventDefault();
  btn.classList.add('loading');

  const lineKey = btn.dataset.lineKey;
  const qty = parseInt(btn.dataset.qty);
console.log("qty", qty);
  const variantId = btn.dataset.targetVariant;
  const sellingPlanId = btn.dataset.targetPlan;

  const cartDrawer = document.querySelector('cart-drawer');

  if (!lineKey || !variantId || !cartDrawer) {
    console.error("Missing data or cart drawer");
    btn.classList.remove('loading');
    return;
  }

  const sections = cartDrawer.getSectionsToRender().map(s => s.id);

  /* STEP 1: REMOVE */
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      quantity: 0
    })
  })
  .then(() => {

    /* STEP 2: ADD + REQUEST SECTIONS */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
        selling_plan: sellingPlanId,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

  })
  .then(res => res.json())
  .then(data => {

    /* STEP 3: RENDER CART */
    cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents(data);

  })
  .catch(err => console.error(err))
  .finally(() => {
    btn.classList.remove('loading');
  });
});
